var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticStyle:{"width":"40px","height":"40px"},style:({ backgroundColor: _vm.color,color:'white' }),attrs:{"circle":""},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.dic[_vm.k]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }